module.exports = "//cdn.mxpnl.com/static/asset-cache/ca352e4677849e9574671178d52f2b18/iron/common/assets/images/charts/logarithmic-stacked-line.svg";